const formActions = {
    LOAD_CLIENT_INFO: "LOAD_CLIENT_INFO",
    GET_FORM_VALUES: "GET_FORM_VALUES",
    GET_FORM_VALUES_RESPONSE: "GET_FORM_VALUES_RESPONSE",
    LOAD_FORM_CLIENT: "LOAD_FORM_CLIENT",
};

export default formActions;
